import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { ProjectMessagesPanel } from './ProjectMessagesPanel';
import { MessageCircle } from 'lucide-react';

interface MessagesSlideOverProps {
  projectId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function MessagesSlideOver({ projectId, open, onOpenChange }: MessagesSlideOverProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-md flex flex-col p-0">
        <SheetHeader className="px-4 pt-4 pb-3 border-b">
          <SheetTitle className="flex items-center gap-2">
            <MessageCircle className="w-4 h-4 text-violet-600" />
            Messages
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto p-4">
          <ProjectMessagesPanel projectId={projectId} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
